.wrapper {
  position: relative;
}

.root {
  align-items: center;
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  cursor: pointer;
  display: inline-flex;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  gap: 6px;
  height: 40px;
  outline: none;
  padding: 0 12px;
  transition: border-color 0.15s;
  width: 100%;

  &:hover {
    border-color: var(--color-foreground);
  }
}

.root-size-sm {
  font-size: 13px;
  height: 32px;
}

.root-is-open {
  border-color: var(--color-foreground);
}

.root-is-disabled {
  background: var(--color-secondary);
  cursor: not-allowed;
  opacity: 0.6;
}

.leading-icon {
  color: var(--color-foreground);
  flex-shrink: 0;
  height: 14px;
  width: 14px;
}

.value {
  color: var(--color-foreground);
  flex: 1;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.clear {
  color: var(--color-muted);
  cursor: pointer;
  flex-shrink: 0;
  height: 14px;
  transition: color 0.15s;
  width: 14px;

  &:hover {
    color: var(--color-foreground);
  }
}

.chevron {
  color: var(--color-muted);
  flex-shrink: 0;
  height: 14px;
  transition: transform 0.15s;
  width: 14px;
}

.chevron-open {
  transform: rotate(180deg);
}

.dropdown {
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  box-shadow: 0 4px 16px rgb(0 0 0 / 10%);
  display: flex;
  flex-direction: column;
  gap: 10px;
  left: 0;
  // Fixed width so presets always wrap into a compact 2-row layout regardless
  // of viewport width. JS boundary detection shifts the dropdown left/right to
  // stay within the viewport on narrow screens.
  padding: 10px;
  position: absolute;
  top: calc(100% + 4px);
  width: 360px;
  z-index: 50;
}

// align="right" is a hint only — the JS boundary check shifts the dropdown
// left as needed. No CSS position change needed here.

.presets {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.preset {
  background: transparent;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  color: var(--color-foreground);
  cursor: pointer;
  flex: 1;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  height: 32px;
  padding: 0 10px;
  transition: background-color 0.1s, border-color 0.1s;
  white-space: nowrap;

  &:hover {
    background: var(--color-secondary);
  }
}

.preset-active {
  background: var(--color-secondary);
  border-color: var(--color-foreground);
}

.custom-row {
  display: flex;
  gap: 10px;
}

.custom-field {
  color: var(--color-muted);
  display: flex;
  flex: 1;
  flex-direction: column;
  font-size: 12px;
  gap: 4px;

  input {
    background: var(--color-background);
    border: 1px solid var(--color-border);
    border-radius: 8px;
    color: var(--color-foreground);
    font-family: inherit;
    font-size: 13px;
    height: 32px;
    padding: 0 8px;

    &:focus {
      border-color: var(--color-foreground);
      outline: none;
    }
  }
}
